<template>
<div class="chapter">
<div class="inner_page">
<div class="move">
<p class="para">Lilly Hurd is an American writer who is passionate about Scotland, her ancestral home. While working in corporate Boston in 2016, she decided to trade her high heels for hiking boots. She now splits her time between her home state of Maine and Scotland, exploring off-the-beaten paths and writing about her wanders on her blog Find Her in the Highlands.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm01.vue?994a73d4